import { useState } from "react";
import { Loader2, Building2, Search } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const formatAteco = (c) => { const d = String(c || "").replace(/\D/g, ""); return d.length >= 4 ? `${d.slice(0, 2)}.${d.slice(2, 4)}${d.length > 4 ? "." + d.slice(4, 6) : ""}` : d; };

export function ImpresaLookup({ onImpresa, compact = false }) {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [cand, setCand] = useState([]);
  const scegli = async (piva) => {
    setBusy(true);
    try { const { data } = await api.get("/public/imprese/cerca", { params: { q: piva } }); setCand([]); onImpresa(data.impresa); toast.success(`${data.impresa.ragione_sociale}: ATECO ${formatAteco(data.impresa.ateco) || "non disponibile"}`); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const cerca = async (e) => {
    e?.preventDefault(); if (!q.trim()) return; setBusy(true);
    try {
      const { data } = await api.get("/public/imprese/cerca", { params: { q } });
      if (data.tipo === "impresa") { setCand([]); onImpresa(data.impresa); toast.success(`${data.impresa.ragione_sociale}: ATECO ${formatAteco(data.impresa.ateco) || "non disponibile"}`); }
      else if (data.candidati.length === 1) await scegli(data.candidati[0].partita_iva);
      else if (!data.candidati.length) toast.error("Nessuna impresa trovata con questo nome: prova con la partita IVA");
      else setCand(data.candidati);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className={`rounded-xl border border-[#0070BA]/30 bg-[#0070BA]/5 ${compact ? "p-3" : "p-4"}`} data-testid="impresa-lookup">
      <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#003087] flex items-center gap-1.5"><Building2 size={13} /> Recupera il codice ATECO dal Registro Imprese</p>
      <form onSubmit={cerca} className="mt-2 flex flex-col sm:flex-row gap-2">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Partita IVA o ragione sociale (es. Casa Energia Green)" className="h-10 bg-white" data-testid="impresa-lookup-q" />
        <Button type="submit" disabled={busy || q.trim().length < 3} className="h-10 rounded-full bg-[#0070BA] hover:bg-[#003087] px-5" data-testid="impresa-lookup-submit">{busy ? <Loader2 className="animate-spin" size={16} /> : <><Search size={14} className="mr-1.5" /> Recupera ATECO</>}</Button>
      </form>
      {cand.length > 0 && <ul className="mt-2 divide-y divide-slate-200 rounded-lg bg-white border border-slate-200" data-testid="impresa-lookup-candidati">
        {cand.map((c) => <li key={c.partita_iva}><button type="button" onClick={() => scegli(c.partita_iva)} className="w-full text-left px-3 py-2 text-sm hover:bg-slate-50 flex flex-wrap items-center gap-x-3" data-testid={`impresa-lookup-cand-${c.partita_iva}`}><b className="text-slate-900">{c.ragione_sociale}</b><span className="text-xs text-slate-500">P.IVA {c.partita_iva} · {c.comune}{c.provincia && ` (${c.provincia})`}{c.stato_attivita && ` · ${c.stato_attivita.toLowerCase()}`}</span></button></li>)}
      </ul>}
    </div>
  );
}
